export enum VacancyType {
    internship = 'internship',
    job = 'job',
}
